import React, { Fragment } from "react";

// Very Empty right now, but use this for functionality highly specific to the App.
const PlastXProvider = ({ children }) => {
  return <Fragment>{children}</Fragment>;
};

export default PlastXProvider;
